module.exports = __webpack_public_path__ + "img/phil-icons.7dd6eca2.png";